/**
 * @module shop/product-details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

interface QueryParams {
  type: string;
  limit?: number;
  offset?: number;
  search?: string;
  sortBy?: string;
  filter?: string;
}

export class ReviewsQuery {
  public queryParams: QueryParams;
  constructor(
    type: string,
    filterCriterion?: string,
    queryString?: string,
    queryParams?: QueryParams
  ) {
    this.queryParams = queryParams
      ? queryParams
      : {
          type: type ? type : 'landing',
        };
    if (filterCriterion) {
      this.queryParams[filterCriterion] = queryString;
    }
  }

  /**
   * Function to set limit
   * @param limit of type number
   */
  public setLimit(limit: number): void {
    this.queryParams.limit = limit;
  }
  /**
   * Function to set offset
   * @param offset of type number
   */
  public setOffset(offset: number): void {
    this.queryParams.offset = offset;
  }
}
